// client/src/routes/admin/email.tsx — „E-mail" · D-2676.
//
// How this installation sends mail, a test message through the relay, and the outbound log
// (D-2681, D-2682). Gated once by `/admin`'s layout route, like its siblings: the three API
// routes behind it demand `Platform.Admin`, which is the one code the layout checks.

import { createFileRoute } from '@tanstack/react-router';

import { PlatformEmailScreen } from '@/features/platform/PlatformEmailScreen';

export const Route = createFileRoute('/admin/email')({
  component: PlatformEmailScreen,
});
